import { render, staticRenderFns } from "./SuspensionList.vue?vue&type=template&id=141fff41&"
import script from "./SuspensionList.vue?vue&type=script&lang=js&"
export * from "./SuspensionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports